import { render } from "./LocationUpdate.vue?vue&type=template&id=27fc9068"
import script from "./LocationUpdate.vue?vue&type=script&lang=ts"
export * from "./LocationUpdate.vue?vue&type=script&lang=ts"
script.render = render

export default script